export const NAME = 'enrollment';

export const REQUEST_ENROLLMENT = 'REQUEST_ENROLLMENT';
export const SUCCESS_ENROLLMENT = 'SUCCESS_ENROLLMENT';
export const FAILURE_ENROLLMENT = 'FAILURE_ENROLLMENT';

export const EMAIL_ALREADY_USED_STATUS_CODE = 409;



// WEBPACK FOOTER //
// ./src/services/enrollment/constants.js